import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdvancedDataSource } from 'src/app/controls/advanced-gridview/datasources/advanced-datasource';
import { AdvancedGridviewModel } from 'src/app/controls/advanced-gridview/models/advanced-gridview-model';
import { ColumnDefinition } from 'src/app/controls/advanced-gridview/models/column-definition';
import { ColumnListDefinition } from 'src/app/controls/advanced-gridview/models/column-list-definition';
import { ColumnType } from 'src/app/controls/advanced-gridview/models/column-type';
import { MenuITemAction } from 'src/app/controls/advanced-gridview/models/menu-item-action';
import { MenuItemEvent } from 'src/app/controls/advanced-gridview/models/menu-item-event';
import { SortInfos } from 'src/app/controls/advanced-gridview/models/sort-infos';
import { FilterType } from 'src/app/controls/filters/models/filter-type';
import { ListItem } from 'src/app/controls/filters/models/list-item';
import { DefaultListComponent } from 'src/app/controls/list/default-list/default-list.component';
import { EnumHelper } from 'src/app/helpers/enum-helper';
import { Rights } from 'src/app/models/enums/rights';
import { Group } from 'src/app/models/group';
import { GroupsService } from 'src/app/services/groups.service';
import { MemoryService } from 'src/app/services/memory.service';
import { NotificationService } from 'src/app/services/notification-service';
import { RolesService } from 'src/app/services/roles.service';
import { AdvancedGridviewComponent } from '../../../controls/advanced-gridview/advanced-gridview.component';

@Component({
    selector: 'app-groups-list',
    templateUrl: './groups-list.component.html',
    styleUrls: ['./groups-list.component.scss'],
    imports: [AdvancedGridviewComponent]
})
export class GroupsListComponent extends DefaultListComponent<Group> implements OnInit {
    /**
     * Configuration des colonnes de la liste.
     */
    tableConfig: ColumnDefinition[] = null;

    /**
     * Constructeur
     * @param dialog : Service pour ouvrir des boites de dialogue.
     * @param memoryService : Service pour récupérer les informations en mémoire.
     * @param enumHelper : Classe utilitaire pour les énumérations.
     * @param GroupsService Service de gestion des groupes.
     * @param rolesService Service de gestion des rôles.
     */
    constructor(
        public override dialog: MatDialog,
        protected override memoryService: MemoryService,
        public enumHelper: EnumHelper,
        private groupsService: GroupsService,
        private rolesService: RolesService,
        private spinner: NgxSpinnerService,
        private notificationService: NotificationService
    ) {
        super(dialog, memoryService);

        // Specifie des colonnes en fonction des droits utilisateurs
        if (this.memoryService.getConnectedUser().params.idVisible === true) {
            this.tableConfig = [
                new ColumnDefinition('id', 'Id', ColumnType.Numeric, FilterType.Text, 1, 20, true),
                new ColumnDefinition('name', 'Nom', ColumnType.Text, FilterType.Text, 2, 35, true),
                new ColumnListDefinition('parentGroupId', 'Groupe Parent', FilterType.List, 3, 20, true, false),
                new ColumnListDefinition('roles', 'Rôles', FilterType.List, 4, 20, true, false),
            ];
        } else {
            this.tableConfig = [
                new ColumnDefinition('name', 'Nom', ColumnType.Text, FilterType.Text, 2, 45, true),
                new ColumnListDefinition('parentGroupId', 'Groupe Parent', FilterType.List, 3, 25, true, false),
                new ColumnListDefinition('roles', 'Rôles', FilterType.List, 4, 25, true, false),
            ];
        }

        this.AddMenuItem('Éditer', MenuITemAction.Update, Rights.GroupAndUserEdit);
        this.AddMenuItem('Réinitialiser', MenuITemAction.Reset, Rights.GroupAndUserDelete);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        this.dataSource = new AdvancedDataSource(null, this.groupsService, this.spinner, this.notificationService);
        this.filteredTableModel = new AdvancedGridviewModel(this.tableConfig, new SortInfos('name', 'asc'));

        // Ajout des listes déroulantes
        // attente de 500ms pour que la gridView ait le temps de se remplir.
        setTimeout(() => {
            this.loadListColumnFilterDatas();
        }, 500);
    }

    /**
     * Appellé lorsque l'utilisateur clique sur un élément du menu contextuel.
     * @param event : Événement retourné par le menu contextuel.
     */
    public onAction(event: MenuItemEvent<Group>): void {
        if (event.action == MenuITemAction.Read) {
            // Cas de la consultation.
            this.itemDisplayed.emit(event.context);
        } else if (event.action == MenuITemAction.Update) {
            // Cas de la mise à jour.
            this.itemEdited.emit(event.context);
        } else if (event.action == MenuITemAction.Reset) {
            // Cas de la suppression --> affichage de la boite de dialogue de confirmation.
            this.displayResetConfirmationDialog(`Vous êtes sur le point de réinitialiser le groupe ${event.context.id}.`, event.context);
        }
    }

    /**
     * Charge les éléments des filtres des colonnes de type liste.
     */
    private loadListColumnFilterDatas(): void {
        this.groupsService.List(null, null, null, null).subscribe((x) => {
            var listItem = x.value.map<ListItem<string>>((v) => <ListItem<string>>{ value: v.id.toString(), text: v.name });
            this.loadColumn(
                this.filteredTableModel.displayedColumnsDefinitions.find(
                    (x) => this.enumHelper.areEquals(ColumnType, x.type, ColumnType.List) && x.columnName === 'parentGroupId'
                ) as ColumnListDefinition<string>,
                listItem
            );
        });

        this.rolesService.ListAttributable().subscribe((x) => {
            var listItem = x.value.map<ListItem<string>>((v) => <ListItem<string>>{ value: v.id.toString(), text: v.name });
            this.loadColumn(
                this.filteredTableModel.displayedColumnsDefinitions.find(
                    (x) => this.enumHelper.areEquals(ColumnType, x.type, ColumnType.List) && x.columnName === 'roles'
                ) as ColumnListDefinition<string>,
                listItem
            );
        });
    }
}
